const URL = {
  LOGIN: '/login',
  LOGOUT: '/logout',
  SIGNUP: '/signup',
  DASHBOARD: '/dashboard',
  RESET_PASSWORD: '/password-reset',
};

export { URL };
